"use client"

const MAX_BURST = 2
const RETRY_WINDOW_MS = 30 * 1000
const MAX_SESSION_RELOADS = 5
const RELOAD_KEY = 'chunk-error-last-refresh'
const RETRY_COUNT_KEY = 'chunk-error-retry-count'
const SESSION_TOTAL_KEY = 'chunk-error-session-reloads'

let reloadScheduled = false

export function isChunkLoadError(message: string) {
  return (
    message.includes('Loading chunk') ||
    message.includes('ChunkLoadError') ||
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Importing a module script failed')
  )
}

export function isNextChunkAsset(src: string) {
  return (
    src.includes('/_next/static/chunks/') ||
    src.includes('/_next/static/css/')
  )
}

export function scheduleChunkErrorReload(errorMessage: string) {
  if (reloadScheduled) {
    return false
  }

  if (!navigator.onLine) {
    console.warn('检测到 chunk 加载失败，但当前网络离线，暂不自动刷新:', errorMessage)
    return false
  }

  const sessionTotal = Number(sessionStorage.getItem(SESSION_TOTAL_KEY) || '0')
  if (sessionTotal >= MAX_SESSION_RELOADS) {
    console.warn(
      'chunk 自动恢复已达本会话上限（',
      MAX_SESSION_RELOADS,
      ' 次），停止自动刷新，请手动刷新或检查部署/CDN：',
      errorMessage,
    )
    return false
  }

  const now = Date.now()
  const lastRefresh = Number(sessionStorage.getItem(RELOAD_KEY) || '0')
  const previousRetryCount = Number(sessionStorage.getItem(RETRY_COUNT_KEY) || '0')
  const inRetryWindow = lastRefresh > 0 && now - lastRefresh < RETRY_WINDOW_MS
  const retryCount = inRetryWindow ? previousRetryCount : 0

  if (retryCount >= MAX_BURST) {
    console.warn('chunk 短窗口内自动恢复次数已达上限，停止自动刷新:', errorMessage)
    return false
  }

  reloadScheduled = true
  sessionStorage.setItem(SESSION_TOTAL_KEY, String(sessionTotal + 1))
  sessionStorage.setItem(RELOAD_KEY, String(now))
  sessionStorage.setItem(RETRY_COUNT_KEY, String(retryCount + 1))
  console.warn(`检测到 chunk 加载失败，执行第 ${sessionTotal + 1} 次会话级自动恢复:`, errorMessage)

  setTimeout(() => {
    const nextUrl = new URL(window.location.href)
    nextUrl.searchParams.set('__chunk_retry', String(Date.now()))
    window.location.assign(nextUrl.toString())
  }, 120)

  return true
}
